import { useState, useEffect, useCallback } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { RiSettings3Line } from 'react-icons/ri'

import { checkIsPhoneNumberValid, checkIsEmailValid, getAbbreviatedState, checkAmexCardConditonsAdded, checkVisaCardConditonsAdded, checkMasterCardConditonsAdded, checkZip, convertAddress } from '../../services/helper'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import {
    uploadAchInstruction, uploadCardAuthorizationFormFile, getCardAcceptanceEmails
} from '../../redux/actions/vendor'
import { toast } from '../CommonComponents/ToastComponent/toast'
import SupplierBasicInfo from './supplierBasicInfo'
import SupplierCardInfo from './supplierCardInfo'
import SupplierCheckInfo from './supplierCheckInfo'
import SupplierAchInfo from './supplierAchInfo'
import ThreeStateToggleButton from '../CommonComponents/ThreeStateToggleButton'
import { getAllListSupplierInfo } from '../../redux/actions/caller'
import ModalComponent from '../CommonComponents/Modal'
import Contacts from '../ContactsComponent/contacts'
import CreateContact from '../ContactsComponent/createContact'

const CreateSupplierComponent = ({ isCreate = true, listSupplierInfo, supplierBasicInfo, supplierCardAccInfo, supplierPaymentInfo, onBasicInfoSave, onCardInfoSave, onCheckInfoSave, onAchInfoSave, onComplete, isLoadingBasicInfo, isLoadingCardInfo, isLoadingCheckInfo, isLoadingAchInfo, showComplete, onGlobalAccSave, showAdvancedSettings, onShowHideAdvancedSettings, isUpdatingAdvanceSettings, listSupplierId = null, supNameForEIN, isLoading, isDisabledButtons, onBasicPhoneClick, onGetChildrenData, onAssignMaster = () => { }, contacts = [], onGetContactsData, vendorInCallsDetailsId = null }) => {
    const dispatch = useDispatch()
    const store = useStore().getState()
    const history = useHistory()
    const {
        vendor: {
            isCreatingChild
        },
        auth: { user },
        app: {
            createSupplierTabs,
            createSupplierBasicColumns,
            createSupplierAchColumns,
            createSupplierCardColumns,
            createSupplierCheckColumns,
            masterSupplierColumns
        }
    } = store
    const { id } = user

    const usArray = ['united states', 'usa', 'us']
    const tabs = [
        { label: 'Supplier Info', value: 'basic' },
        { label: 'Contacts', value: 'contacts' },
        { label: 'Card Acceptance', value: 'card' },
        { label: 'Check Acceptance', value: 'check' },
        { label: 'ACH Acceptance', value: 'ach' }
    ]
    const multiSelectColumns = ['productSpecificOptions', 'emailRemitRequirements', 'phoneRemitRequirements', 'faxRemitRequirements', 'onlineRemitRequirements', 'posRemitRequirements']

    const genericConditionColumns = [
        { name: 'processingFeeType', value: '$' },
        { name: 'processingFeeValue', value: '' },
        { name: 'processingSecondFeeType', value: '$' },
        { name: 'processingSecondFeeValue', value: '' },
        { name: 'minFeeType', value: '$' },
        { name: 'minFeeValue', value: '' },
        { name: 'maxFeeType', value: '$' },
        { name: 'maxFeeValue', value: '' },
        { name: 'incrementalFeeType', value: '$' },
        { name: 'incrementalFeeValue', value: '' },
        { name: 'minPayment', value: '' },
        { name: 'maxPayment', value: '' },
        { name: 'incrementalPayment', value: '' },
        { name: 'showVariableFee', value: null },
        { name: 'showMinFee', value: false },
        { name: 'showMaxFee', value: false },
        { name: 'showIncrementalFee', value: false },
        { name: 'showAnotherProcessingFee', value: false }
    ]

    const cardConditionColumns = [
        { name: 'amexProcessingFeeType', value: '$' },
        { name: 'amexProcessingFeeValue', value: '' },
        { name: 'amexSecondProcessingFeeType', value: '$' },
        { name: 'amexSecondProcessingFeeValue', value: '' },
        { name: 'amexMinPaymentFeeType', value: '$' },
        { name: 'amexMinPaymentFeeValue', value: '' },
        { name: 'amexMaxPaymentFeeType', value: '$' },
        { name: 'amexMaxPaymentFeeValue', value: '' },
        { name: 'amexIncrementalFeeType', value: '$' },
        { name: 'amexIncrementalFeeValue', value: '' },
        { name: 'amexIncrementalPaymentAmount', value: '' },
        { name: 'americanExpressMinPaymnet', value: '' },
        { name: 'americanExpressMaxPayment', value: '' },
        { name: 'isAcceptAmexVariableFee', value: null },
        { name: 'visaProcessingFeeType', value: '$' },
        { name: 'visaProcessingFeeValue', value: '' },
        { name: 'visaSecondProcessingFeeType', value: '$' },
        { name: 'visaSecondProcessingFeeValue', value: '' },
        { name: 'visaMinPaymentFeeType', value: '$' },
        { name: 'visaMinPaymentFeeValue', value: '' },
        { name: 'visaMaxPaymentFeeType', value: '$' },
        { name: 'visaMaxPaymentFeeValue', value: '' },
        { name: 'visaIncrementalFeeType', value: '$' },
        { name: 'visaIncrementalFeeValue', value: '' },
        { name: 'visaIncrementalPaymentAmount', value: '' },
        { name: 'visaMinPayment', value: '' },
        { name: 'visaMaxPayment', value: '' },
        { name: 'isAcceptVisaVariableFee', value: null },
        { name: 'mastercardProcessingFeeType', value: '$' },
        { name: 'mastercardProcessingFeeValue', value: '' },
        { name: 'mastercardSecondProcessingFeeType', value: '$' },
        { name: 'mastercardSecondProcessingFeeValue', value: '' },
        { name: 'mastercardMinPaymentFeeType', value: '$' },
        { name: 'mastercardMinPaymentFeeValue', value: '' },
        { name: 'mastercardMaxPaymentFeeType', value: '$' },
        { name: 'mastercardMaxPaymentFeeValue', value: '' },
        { name: 'mastercardIncrementalFeeType', value: '$' },
        { name: 'mastercardIncrementalFeeValue', value: '' },
        { name: 'mastercardIncrementalPaymentAmount', value: '' },
        { name: 'mastercardMinPayment', value: '' },
        { name: 'mastercardMaxPayment', value: '' },
        { name: 'isAcceptMasterCardVariableFee', value: null }
    ]

    const defaultCardFeeInfo = {
        showHideFee: {
            showAmexMinFee: false,
            showAmexMaxFee: false,
            showAmexIncrementalFee: false,
            showVisaMinFee: false,
            showVisaMaxFee: false,
            showVisaIncrementalFee: false,
            showMasterMinFee: false,
            showMasterMaxFee: false,
            showMasterIncrementalFee: false,
            showDiscoverMinFee: false,
            showDiscoverMaxFee: false,
            showDiscoverIncrementalFee: false,
            showAmexSecondProcessingFee: false,
            showVisaSecondProcessingFee: false,
            showMasterSecondProcessingFee: false,
            showDiscoverSecondProcessingFee: false
        }
    }

    const [currentTab, setCurrentTab] = useState('basic')
    const [isGlobalAcceptance, setIsGlobalAcceptance] = useState(null)
    const [basicInfo, setBasicInfo] = useState({})
    const [childBasicInfo, setChildBasicInfo] = useState({})
    const [cardInfo, setCardInfo] = useState({})
    const [childCardInfo, setChildCardInfo] = useState({})
    const [achInfo, setAchInfo] = useState({})
    const [checkInfo, setCheckInfo] = useState({})
    const [childPaymentInfo, setChildPaymentInfo] = useState({})
    const [achInstructionFile, setAchInstructionFile] = useState(null)
    const [cardAuthorizationFormFile, setCardAuthorizationFormFile] = useState(null)
    const [addCardEmailValues, setAddCardEmailValues] = useState({})
    const [supplierPrimaryCardEmail, setSupplierPrimaryCardEmail] = useState('')
    const [addedEmailValues, setAddedEmailValues] = useState([])
    const [isPhoneValid, setIsPhoneValid] = useState('')
    const [isFaxValid, setIsFaxValid] = useState(true)
    const [isBasicPhoneValid, setIsBasicPhoneValid] = useState('')
    const [isBasicFaxValid, setIsBasicFaxValid] = useState(true)
    const [isNaicsValid, setIsNaicsValid] = useState(true)
    const [isSicValid, setIsSicValid] = useState(true)
    const [progress, setProgress] = useState(0)
    const [cardEmailType, setcardEmailType] = useState('')
    const [isValidatingBasicPhone, setIsValidatingBasicPhone] = useState(false)
    const [isValidatingCardPhone, setIsValidatingCardPhone] = useState(false)
    const [isEmailValid, setIsEmailValid] = useState('')
    const [isValidatingCardEmail, setIsValidatingCardEmail] = useState(false)
    const [isBasicEmailValid, setIsBasicEmailValid] = useState('')
    const [isValidatingBasicEmail, setIsValidatingBasicEmail] = useState(false)
    const [isAchEmailValid, setIsAchEmailValid] = useState('')
    const [isValidatingAchEmail, setIsValidatingAchEmail] = useState(false)
    const [basicPhoneCountryCode, setBasicPhoneCountryCode] = useState('')
    const [cardPhoneCountryCode, setCardPhoneCountryCode] = useState('')
    const [deliveryMethodsFeeValues, setDeliveryMethodsFeeValues] = useState({})
    const [cardFeeInfo, setCardFeeInfo] = useState(defaultCardFeeInfo)
    const [showAcceptancePerCard, setShowAcceptancePerCard] = useState(false)
    const [accPerCardText, setAccPerCardText] = useState('Acceptance Per Card')
    const [isPortalUrlValid, setIsPortalUrlValid] = useState(true)
    const [isThirdPartyPortalUrlValid, setIsThirdPartyPortalUrlValid] = useState(true)
    const [isIVRPhoneValid, setIsIVRPhoneValid] = useState('')
    const [isValidatingIVRPhone, setIsValidatingIVRPhone] = useState(false)
    const [ivrCountryCode, setIVRCountryCode] = useState('')
    const [genericFeeValues, setGenericFeeValues] = useState({
        showMinFee: false,
        showMaxFee: false,
        showIncrementalFee: false,
        showAnotherProcessingFee: false,
        showCreditCards: null,
        processingFeeType: '$',
        processingFeeValue: '',
        processingSecondFeeType: '$',
        processingSecondFeeValue: '',
        minFeeType: '$',
        minFeeValue: '',
        maxFeeType: '$',
        maxFeeValue: '',
        incrementalFeeType: '$',
        incrementalFeeValue: '',
        minPayment: '',
        maxPayment: '',
        incrementalPayment: '',
        showVariableFee: null,
        showCardConditions: null
    })
    const [portalURLError, setPortalURLError] = useState(false)
    const [showAddNewContact, setShowAddNewContact] = useState(false)
    const [contactDataFromField, setContactDataFromField] = useState({})
    const [supplierContacts, setSupplierContacts] = useState([])
    const [allContacts, setAllContacts] = useState([])
    const [isEmailCreatedOrSelected, setIsEmailCreatedOrSelected] = useState(false)
    const [removeEmailValues, setRemoveEmailValues] = useState({});

    useEffect(() => {
        if (listSupplierId) {
            dispatch(getAllListSupplierInfo({ listSupplierId: listSupplierId, vendorInCallsDetailsId: null, isInCalls: null })).then(async (result) => {
                const cardInfo = {}
                cardInfo['cardInfo'] = result?.['cardInfo'] || {}
                cardInfo['cardEmailsInfo'] = await dispatch(getCardAcceptanceEmails(listSupplierId, null, null))
                setChildCardInfo(cardInfo)
                setChildPaymentInfo(result?.paymentInfo || {})
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to get List Supplier Data!'
                })
            })
        }
    }, [])

    const setInitialSupplierInfo = useCallback(async (columns, supplierBasicInfo, listSupplierInfo, contacts, basicInfo) => {
        const usArray = ['united states', 'usa', 'us']
        let tmpChildBasicInfo = {}
        let tmpBasicInfo = {}
        var phoneNumber = ''
        let stateCode = ''
        let supplierColumns = [...columns]
        supplierColumns.push({ name: 'phoneExtension', label: 'Phone Extension' })
        const basicData = {}

        if (!supplierBasicInfo?.id) {
            Object.keys(basicInfo || {}).forEach(key => {
                if (key === 'phone') {
                    basicData[key] = basicInfo?.phoneContactId?.value || basicInfo[key]?.value
                } else if (key === 'email') {
                    basicData[key] = basicInfo?.emailContactId?.value || basicInfo[key]?.value
                } else if (key !== 'id') {
                    basicData[key] = basicInfo[key]?.value
                }
            })
            supplierBasicInfo = { ...basicData }
        }
        supplierColumns.forEach(async (column) => {
            if (column.name === 'fax') {
                if (supplierBasicInfo) {
                    if (!supplierBasicInfo?.[column.name] || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(supplierBasicInfo?.[column.name])) {
                        setIsBasicFaxValid(true)
                    } else {
                        setIsBasicFaxValid(false)
                    }
                } else {
                    setIsBasicFaxValid(true)
                }
            }

            if (supplierBasicInfo && column.name === 'abbreviatedState') {
                stateCode = getAbbreviatedState('', supplierBasicInfo?.state)
                tmpBasicInfo['abbreviatedState'] = stateCode
            }

            if ((supplierBasicInfo || listSupplierInfo) && column.name === 'phone') {
                var phone = ''

                const tmpValue = supplierBasicInfo?.[column.name] ? supplierBasicInfo?.[column.name] : ''
                const supPhone = (supplierBasicInfo?.[column.name] && /^\d+$/.test(supplierBasicInfo?.[column.name]) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(supplierBasicInfo?.[column.name])) ? supplierBasicInfo?.contacts?.find(data => data?.id === parseInt(supplierBasicInfo?.[column.name]))?.[column.name] : (supplierBasicInfo?.[column.name] || '')
                const phoneContactId = (supplierBasicInfo?.[column.name] && /^\d+$/.test(supplierBasicInfo?.[column.name]) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(supplierBasicInfo?.[column.name])) ? contacts?.find(data => data?.id === parseInt(supplierBasicInfo?.[column.name]))?.id : null
                phone = !supPhone ? '' : supPhone?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? supPhone : supplierBasicInfo?.['country'] && usArray.includes(supplierBasicInfo?.['country']?.toLowerCase()) && supPhone?.startsWith('1') ? supPhone : ((supplierBasicInfo?.['country'] && !usArray.includes(supplierBasicInfo?.['country']?.toLowerCase()))) ? supPhone : supPhone?.startsWith('1') ? supPhone : '1 ' + supPhone
                // }

                var listSupPhone = (listSupplierInfo?.[column.name] && /^\d+$/.test(listSupplierInfo?.[column.name]) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(listSupplierInfo?.[column.name])) ? listSupplierInfo?.contacts?.find(data => data?.id === parseInt(listSupplierInfo?.[column.name]))?.[column.name] : (listSupplierInfo?.[column.name] || '')

                if (listSupPhone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(listSupPhone) || listSupPhone?.length <= 3)) {
                    listSupPhone = '';
                } else {
                    listSupPhone = !listSupPhone ? '' : listSupPhone?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? listSupPhone : listSupplierInfo?.['country'] && listSupplierInfo?.['country']?.toLowerCase() === 'united states' && listSupPhone?.startsWith('1') ? listSupPhone : ((listSupplierInfo?.['country'] && listSupplierInfo?.['country']?.toLowerCase() !== 'united states')) ? listSupPhone : listSupPhone?.startsWith('1') ? listSupPhone : '1 ' + listSupPhone
                }

                tmpBasicInfo = {
                    ...tmpBasicInfo,
                    [column.name]: {
                        label: phone || '',
                        value: phone || ''
                    },
                    phoneContactId: {
                        label: phoneContactId || null,
                        value: phoneContactId || null
                    }
                }

                tmpChildBasicInfo = {
                    ...tmpChildBasicInfo,
                    [column.name]: {
                        label: listSupPhone || '',
                        value: listSupPhone || ''
                    }
                }
            } else if (column.name === 'email') {
                const tmpValue = supplierBasicInfo?.[column.name] ? supplierBasicInfo?.[column.name] : ''
                var email = tmpValue && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.email : (tmpValue || '')
                email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email) ? email : ''
                const emailContactId = tmpValue && /^\d+$/.test(tmpValue) ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
                tmpBasicInfo = {
                    ...tmpBasicInfo,
                    [column.name]: {
                        label: email || '',
                        value: email || ''
                    },
                    emailContactId: {
                        label: emailContactId || null,
                        value: emailContactId || null
                    }
                }

                const listSupEmail = (listSupplierInfo?.[column.name] && /^\d+$/.test(listSupplierInfo?.[column.name])) ? listSupplierInfo?.contacts?.find(data => data?.id === parseInt(listSupplierInfo?.[column.name]))?.[column.name] : (listSupplierInfo?.[column.name] || '')
                tmpChildBasicInfo = {
                    ...tmpChildBasicInfo,
                    [column.name]: {
                        label: listSupEmail || '',
                        value: listSupEmail || '',
                    }
                }
            } else {
                tmpBasicInfo = {
                    ...tmpBasicInfo,
                    [column.name]: {
                        label: supplierBasicInfo?.[column.name] || '',
                        value: supplierBasicInfo?.[column.name] || '',
                    }
                }
                tmpChildBasicInfo = {
                    ...tmpChildBasicInfo,
                    [column.name]: {
                        label: listSupplierInfo?.[column.name] || '',
                        value: listSupplierInfo?.[column.name] || '',
                    }
                }
            }
        })

        tmpBasicInfo["id"] = supplierBasicInfo?.['id']

        if (supplierBasicInfo) {
            var phoneNumber = ''
            const tmpValue = supplierBasicInfo?.phone ? supplierBasicInfo?.phone : ''
            const supPhone = tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.phone : (tmpValue || '')
            const tmpEmailValue = supplierBasicInfo?.email ? supplierBasicInfo?.email : ''
            var email = tmpEmailValue ? contacts?.find(data => data?.id === parseInt(tmpEmailValue))?.email : (tmpEmailValue || '')
            email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email) ? email : ''
            if (supPhone && (!/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(supPhone) || supPhone?.length <= 3)) {
                phoneNumber = '';
            } else {
                phoneNumber = !supPhone ? '' : supPhone?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? supPhone : supplierBasicInfo?.['country'] && usArray.includes(supplierBasicInfo?.['country']?.toLowerCase()) && supPhone?.startsWith('1') ? supPhone : ((supplierBasicInfo?.['country'] && !usArray.includes(supplierBasicInfo?.['country']?.toLowerCase()))) ? supPhone : supPhone.startsWith('1') ? supPhone : '1 ' + supPhone
            }

            handleBasicInfoPhoneNumberFocusOut(null, null, phoneNumber, true, tmpBasicInfo)
            handleBasicInfoEmailFocusOut(email)
        } else {
            setBasicInfo(tmpBasicInfo)
        }

        setChildBasicInfo(tmpChildBasicInfo)
    }, [])

    const setInitialSupplierAchInfo = useCallback(async (columns, paymentInfo, contacts) => {
        console.log("paymentInfo", paymentInfo)
        let tmpAchInfo = {}
        columns.forEach(achColumn => {
            if (achColumn.name === 'emailAch') {
                setIsAchEmailValid(true)
                const tmpValue = paymentInfo?.[achColumn.name] || ''
                const email = tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.email : ''
                const emailId = contacts?.find(data => data?.id === parseInt(tmpValue))?.id || null
                tmpAchInfo = {
                    ...tmpAchInfo,
                    [achColumn.name]: {
                        label: email,
                        value: email
                    },
                    emailContactId: {
                        label: emailId,
                        value: emailId
                    }
                }
            } else {
                tmpAchInfo = {
                    ...tmpAchInfo,
                    [achColumn.name]: {
                        label: Object.keys(paymentInfo ? paymentInfo : {})?.length === 0 ? typeof achColumn.defaultValue !== 'string' ? JSON?.stringify(achColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(achColumn.defaultValue).substring(1) : achColumn.defaultValue : paymentInfo?.[achColumn.name],
                        value: Object.keys(paymentInfo ? paymentInfo : {})?.length === 0 ? achColumn.defaultValue : paymentInfo?.[achColumn.name]
                    }
                }
            }
        })
        setAchInfo(tmpAchInfo)
        setAchInstructionFile(null)
    }, [])

    const setInitialSupplierCheckInfo = useCallback(async (columns, paymentInfo) => {
        let tmpCheckInfo = {}
        columns.forEach(checkColumn => {
            if (checkColumn.name === 'cashDiscountType') {
                tmpCheckInfo = {
                    ...tmpCheckInfo,
                    [checkColumn.name]: {
                        label: Object.keys(paymentInfo ? paymentInfo : {})?.length === 0 ? '%' : paymentInfo?.[checkColumn.name] === 'Percentage' ? '%' : '$',
                        value: Object.keys(paymentInfo ? paymentInfo : {})?.length === 0 ? checkColumn.defaultValue : paymentInfo?.[checkColumn.name]
                    }
                }
            } else {
                tmpCheckInfo = {
                    ...tmpCheckInfo,
                    [checkColumn.name]: {
                        label: Object.keys(paymentInfo ? paymentInfo : {})?.length === 0 ? typeof checkColumn.defaultValue !== 'string' ? JSON?.stringify(checkColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(checkColumn.defaultValue).substring(1) : checkColumn.defaultValue : paymentInfo?.[checkColumn.name],
                        value: Object.keys(paymentInfo ? paymentInfo : {})?.length === 0 ? checkColumn.defaultValue : paymentInfo?.[checkColumn.name]
                    }
                }
            }
        })
        setCheckInfo(tmpCheckInfo)
    }, [])

    const setInitialSupplierCardInfo = useCallback(async (columns, supplierCardAccInfo, contacts) => {
        var feeInfo = {}
        supplierCardAccInfo?.cardFeeInfo?.map((feeData) => {
            feeInfo = {
                ...feeInfo,
                [feeData?.deliveryMethod]: feeData
            }
        })
        setDeliveryMethodsFeeValues(feeInfo)
        let tmpCardInfo = {}
        columns.forEach(cardColumn => {
            if (cardColumn.name === 'ccProcessingTime') {
                tmpCardInfo = {
                    ...tmpCardInfo,
                    [cardColumn.name]: {
                        label: (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length) ? supplierCardAccInfo?.cardInfo?.[cardColumn.name] : cardColumn.defaultValue + ' Days',
                        value: (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length) ? supplierCardAccInfo?.cardInfo?.[cardColumn.name] : cardColumn.defaultValue
                    }
                }
            } else if (cardColumn.name === 'cardDiscountType') {
                tmpCardInfo = {
                    ...tmpCardInfo,
                    [cardColumn.name]: {
                        label: (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length === 0) ? '%' : supplierCardAccInfo?.cardInfo?.[cardColumn.name] === 'Percentage' ? '%' : '$',
                        value: (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length === 0) ? 'Percentage' : supplierCardAccInfo?.cardInfo?.[cardColumn.name]
                    }
                }
            } else if (cardColumn.name === 'cardPaymentByPhoneValue' || cardColumn.name === 'cardPaymentIVRPhone') {
                setIsPhoneValid(true)
                const tmpValue = supplierCardAccInfo?.cardInfo?.[cardColumn.name] || ''
                const phone = tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.phone : ''

                var cardPhoneNumber = '';
                cardPhoneNumber = (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length === 0) || !phone ? '' : phone?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? phone : '1 ' + phone

                tmpCardInfo = {
                    ...tmpCardInfo,
                    [cardColumn.name]: {
                        label: cardPhoneNumber,
                        value: cardPhoneNumber,
                    }
                }
                if (cardColumn.name === 'cardPaymentByPhoneValue') {
                    tmpCardInfo = {
                        ...tmpCardInfo,
                        phoneContactId: {
                            label: tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null,
                            value: tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null,
                        }
                    }
                } else {
                    tmpCardInfo = {
                        ...tmpCardInfo,
                        ivrPhoneContactId: {
                            label: tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null,
                            value: tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null,
                        }
                    }
                }
            } else {
                if (multiSelectColumns.includes(cardColumn.name)) {
                    if (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length === 0) {
                        tmpCardInfo = {
                            ...tmpCardInfo,
                            [cardColumn.name]: cardColumn.defaultValue
                        }
                    } else {
                        let selectOptions = []
                        const selectOptionsArray = supplierCardAccInfo?.cardInfo?.[cardColumn.name] ? supplierCardAccInfo?.cardInfo?.[cardColumn.name]?.split(',') : [];
                        selectOptionsArray.map((option) => {
                            option = option.replace(/^\s+|\s+$/g, "");
                            selectOptions.push({
                                label: (option[0].toUpperCase() + option.slice(1)).replaceAll('-', ' '),
                                value: option
                            })
                        })
                        tmpCardInfo = {
                            ...tmpCardInfo,
                            [cardColumn.name]: selectOptions
                        }
                    }
                } else {
                    tmpCardInfo = {
                        ...tmpCardInfo,
                        [cardColumn.name]: {
                            label: (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length === 0) ? typeof cardColumn.defaultValue !== 'string' ? JSON?.stringify(cardColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(cardColumn.defaultValue).substring(1) : cardColumn.defaultValue : supplierCardAccInfo?.cardInfo?.[cardColumn.name],
                            value: (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length === 0) ? cardColumn.defaultValue : supplierCardAccInfo?.cardInfo?.[cardColumn.name]
                        }
                    }
                }
            }
        })

        setCardFeeInfo({
            ...cardFeeInfo,
            'showHideFee': {
                ...cardFeeInfo?.showHideFee,
                showAmexMinFee: supplierCardAccInfo?.cardInfo?.['amexMinPaymentFeeValue'],
                showAmexMaxFee: supplierCardAccInfo?.cardInfo?.['amexMaxPaymentFeeValue'],
                showAmexIncrementalFee: supplierCardAccInfo?.cardInfo?.['amexIncrementalFeeValue'] || supplierCardAccInfo?.cardInfo?.['amexIncrementalPaymentAmount'],
                showVisaMinFee: supplierCardAccInfo?.cardInfo?.['visaMinPaymentFeeValue'],
                showVisaMaxFee: supplierCardAccInfo?.cardInfo?.['visaMaxPaymentFeeValue'],
                showVisaIncrementalFee: supplierCardAccInfo?.cardInfo?.['visaIncrementalFeeValue'] || supplierCardAccInfo?.cardInfo?.['visaIncrementalPaymentAmount'],
                showMasterMinFee: supplierCardAccInfo?.cardInfo?.['mastercardMinPaymentFeeValue'],
                showMasterMaxFee: supplierCardAccInfo?.cardInfo?.['mastercardMaxPaymentFeeValue'],
                showMasterIncrementalFee: supplierCardAccInfo?.cardInfo?.['mastercardIncrementalFeeValue'] || supplierCardAccInfo?.cardInfo?.['mastercardIncrementalPaymentAmount'],
                showDiscoverMinFee: supplierCardAccInfo?.cardInfo?.['discoverMinPaymentFeeValue'],
                showDiscoverMaxFee: supplierCardAccInfo?.cardInfo?.['discoverMaxPaymentFeeValue'],
                showDiscoverIncrementalFee: supplierCardAccInfo?.cardInfo?.['discoverIncrementalFeeValue'] || supplierCardAccInfo?.cardInfo?.['discoverIncrementalPaymentAmount'],
                showAmexSecondProcessingFee: supplierCardAccInfo?.cardInfo?.amexSecondProcessingFeeValue ? true : false,
                showVisaSecondProcessingFee: supplierCardAccInfo?.cardInfo?.visaSecondProcessingFeeValue ? true : false,
                showMasterSecondProcessingFee: supplierCardAccInfo?.cardInfo?.mastercardSecondProcessingFeeValue ? true : false,
                showDiscoverSecondProcessingFee: supplierCardAccInfo?.cardInfo?.discoverSecondProcessingFeeValue ? true : false,
            }
        })

        if (supplierCardAccInfo?.cardInfo && Object.keys(supplierCardAccInfo?.cardInfo)?.length) {
            setShowAcceptancePerCard(supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard)
            setGenericFeeValues({
                ...genericFeeValues,
                'showCreditCards': (supplierCardAccInfo?.cardInfo?.isAcceptAmericanExpress === null && supplierCardAccInfo?.cardInfo?.isAcceptMasterCard === null && supplierCardAccInfo?.cardInfo?.isAcceptVisa === null) ? null : (supplierCardAccInfo?.cardInfo?.isAcceptAmericanExpress && supplierCardAccInfo?.cardInfo?.isAcceptMasterCard && supplierCardAccInfo?.cardInfo?.isAcceptVisa) ? true : false,
                'processingFeeType': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : supplierCardAccInfo?.cardInfo?.amexProcessingFeeType || '$',
                'processingFeeValue': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : supplierCardAccInfo?.cardInfo?.amexProcessingFeeValue,
                'processingSecondFeeType': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : supplierCardAccInfo?.cardInfo?.amexSecondProcessingFeeType || '$',
                'processingSecondFeeValue': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : supplierCardAccInfo?.cardInfo?.amexSecondProcessingFeeValue,
                'minFeeType': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : supplierCardAccInfo?.cardInfo?.amexMinPaymentFeeType || '$',
                'minFeeValue': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : supplierCardAccInfo?.cardInfo?.amexMinPaymentFeeValue,
                'maxFeeType': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : supplierCardAccInfo?.cardInfo?.amexMaxPaymentFeeType || '$',
                'maxFeeValue': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : supplierCardAccInfo?.cardInfo?.amexMaxPaymentFeeValue,
                'incrementalFeeType': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : supplierCardAccInfo?.cardInfo?.amexIncrementalFeeType || '$',
                'incrementalFeeValue': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : supplierCardAccInfo?.cardInfo?.amexIncrementalFeeValue,
                'minPayment': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : supplierCardAccInfo?.cardInfo?.americanExpressMinPaymnet,
                'maxPayment': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : supplierCardAccInfo?.cardInfo?.americanExpressMaxPayment,
                'incrementalPayment': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : supplierCardAccInfo?.cardInfo?.amexIncrementalPaymentAmount,
                'showMinFee': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? false : supplierCardAccInfo?.cardInfo?.amexMinPaymentFeeValue ? true : false,
                'showMaxFee': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? false : supplierCardAccInfo?.cardInfo?.amexMaxPaymentFeeValue ? true : false,
                'showIncrementalFee': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? false : supplierCardAccInfo?.cardInfo?.amexIncrementalFeeValue ? true : false,
                'showAnotherProcessingFee': supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? false : supplierCardAccInfo?.cardInfo?.amexSecondProcessingFeeValue ? true : false,
                'showVariableFee': (supplierCardAccInfo?.cardInfo?.isAcceptAmexVariableFee === null && supplierCardAccInfo?.cardInfo?.isAcceptMasterCardVariableFee === null && supplierCardAccInfo?.cardInfo?.isAcceptVisaVariableFee === null) ? null : (supplierCardAccInfo?.cardInfo?.isAcceptAmexVariableFee && supplierCardAccInfo?.cardInfo?.isAcceptMasterCardVariableFee && supplierCardAccInfo?.cardInfo?.isAcceptVisaVariableFee) ? true : false,
                'showCardConditions': (supplierCardAccInfo?.cardInfo?.isAcceptAmexCardConditions === null && supplierCardAccInfo?.cardInfo?.isAcceptVisaCardConditions === null && supplierCardAccInfo?.cardInfo?.isAcceptMastercardCardConditions === null) ? null : (supplierCardAccInfo?.cardInfo?.isAcceptAmexCardConditions && supplierCardAccInfo?.cardInfo?.isAcceptVisaCardConditions && supplierCardAccInfo?.cardInfo?.isAcceptMastercardCardConditions) ? true : false
            })

            supplierCardAccInfo?.cardInfo?.isAcceptAcceptancePerCard ? setAccPerCardText('Generic Fee Structure') : setAccPerCardText('Acceptance Per Card')
        }

        var phoneNumber = !tmpCardInfo?.cardPaymentByPhoneValue?.value ? '' : tmpCardInfo?.cardPaymentByPhoneValue?.value?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? tmpCardInfo?.cardPaymentByPhoneValue?.value : '1 ' + tmpCardInfo?.cardPaymentByPhoneValue?.value;
        var ivrPhoneNumber = !tmpCardInfo?.cardPaymentIVRPhone?.value ? '' : tmpCardInfo?.cardPaymentIVRPhone?.value?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? tmpCardInfo?.cardPaymentIVRPhone?.value : '1 ' + tmpCardInfo?.cardPaymentIVRPhone?.value;
        await handleCardPhoneNumberFocusOut(null, null, phoneNumber, 'cardPaymentByPhoneValue')
        await handleCardPhoneNumberFocusOut(null, null, ivrPhoneNumber, 'cardPaymentIVRPhone')

        setIsEmailValid(true)
        setCardInfo(tmpCardInfo)
        setAddCardEmailValues({});
        setCardAuthorizationFormFile(null);
    }, [])

    useEffect(() => {
        if (!createSupplierBasicColumns || createSupplierBasicColumns.length === 0) {
            return
        }
        setInitialSupplierInfo(createSupplierBasicColumns, supplierBasicInfo, listSupplierInfo, contacts, basicInfo)
    }, [supplierBasicInfo, listSupplierInfo, setInitialSupplierInfo, contacts])

    // initial card info
    useEffect(() => {
        if (!createSupplierCardColumns || createSupplierCardColumns.length === 0) {
            return
        }
        setInitialSupplierCardInfo(createSupplierCardColumns, supplierCardAccInfo, contacts)
    }, [supplierCardAccInfo, supplierCardAccInfo?.cardInfo, setInitialSupplierCardInfo])

    // initial ach info
    useEffect(() => {
        if (!createSupplierAchColumns || createSupplierAchColumns.length === 0) {
            return
        }
        setInitialSupplierAchInfo(createSupplierAchColumns, supplierPaymentInfo, contacts)
    }, [supplierPaymentInfo, setInitialSupplierAchInfo, contacts])

    // initial check info
    useEffect(() => {
        if (!createSupplierCheckColumns || createSupplierCheckColumns.length === 0) {
            return
        }
        setInitialSupplierCheckInfo(createSupplierCheckColumns, supplierPaymentInfo)
    }, [supplierPaymentInfo, setInitialSupplierCheckInfo])

    useEffect(async () => {
        if (Object.values(cardInfo).length > 0) {
            await setPhoneAndEmailValues()
        }
    }, [Object.values(cardInfo).length, supplierCardAccInfo?.cardEmailsInfo])

    useEffect(() => {
        setSupplierContacts(contacts)
        setAllContacts(contacts)
    }, [contacts])

    const setPhoneAndEmailValues = async () => {
        if (isEmailCreatedOrSelected) {
            return
        }

        const isEmailValid = async (email) => {
            var valid = await handleCardEmailFocusOut(email, true);
            return valid
        }

        const getEmails = async () => {
            var emailarray = []
            if (supplierCardAccInfo?.cardEmailsInfo?.length > 0) {
                let allAddedEmails = supplierCardAccInfo?.cardEmailsInfo;
                emailarray = await Promise.all(
                    allAddedEmails.map(async (item, ind) => {
                        const email = item?.email ? allContacts?.find(data => data?.id === parseInt(item.email))?.email : ''
                        var index = 'extra-email-name-' + (ind + 1)
                        var valid = await isEmailValid(email)
                        return {
                            [index]: {
                                'email': email,
                                'emailType': item?.emailType,
                                'valid': valid?.valid,
                                emailContactId: item.email
                            }
                        }
                    })
                )
            }
            return emailarray
        };

        let emailValuesArray = await getEmails();
        setAddedEmailValues(emailValuesArray || []);
    }

    const handleUpdateBasicInfo = (colName, item, country, event) => {
        let tmpValue = {
            label: item?.target?.value,
            value: item?.target?.value
        }
        if (colName === 'state' || colName === 'country') {
            if (/^[a-zA-Z\s]+$/.test(item?.target?.value)) {
                tmpValue.value = item?.target?.value
            } else {
                tmpValue.value = item?.target?.value.match(/^[a-zA-Z\s]+/gi) ? item?.target?.value.match(/^[a-zA-Z\s]+/gi)[0] : ''
            }
        } else if (colName === 'fax') {
            tmpValue.value = item?.target?.value
            if (!item?.target?.value || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(item?.target?.value)) {
                setIsBasicFaxValid(true)
            } else {
                setIsBasicFaxValid(false)
            }
        } else if (colName === 'phone') {
            if (tmpValue?.value && tmpValue?.value !== '') {
                setIsBasicPhoneValid(false)
            } else {
                setIsBasicPhoneValid(true)
                setBasicInfo({
                    ...basicInfo, [colName]: tmpValue, phoneContactId: {
                        label: null,
                        value: null
                    }
                })
                return
            }
        } else if (colName === 'email') {
            if (tmpValue?.value && tmpValue?.value !== '') {
                setIsBasicEmailValid(false)
            } else {
                setIsBasicEmailValid(true)
                setBasicInfo({
                    ...basicInfo, [colName]: tmpValue, emailContactId: {
                        label: null,
                        value: null
                    }
                })
                return
            }
        } else if (colName === 'zip') {
            if (/^\d{5}(-\d{4})?$/.test(item?.target?.value)) {
                tmpValue.value = item?.target?.value
            } else {
                tmpValue.value = item?.target?.value.match(/^\d{1,5}(-\d{0,4})?/gi) ? item?.target?.value.match(/^\d{1,5}(-\d{0,4})?/gi)[0] : ''
            }
        } else if (colName === 'naics') {
            tmpValue.value = item?.target?.value
            if (item?.target?.value === '' || item?.target?.value === undefined || /^(\d{5}|\d{6})?$/i.test(item?.target?.value)) {
                setIsNaicsValid(true)
            } else {
                setIsNaicsValid(false)
            }
        } else if (colName === 'sic') {
            tmpValue.value = item?.target?.value
            if (item?.target?.value === '' || item?.target?.value === undefined || /^\d{4}?$/i.test(item?.target?.value)) {
                setIsSicValid(true)
            } else {
                setIsSicValid(false)
            }
        } else if (colName === 'phoneExtension') {
            if (/^\d{20}$/.test(item?.target?.value)) {
                tmpValue.value = item?.target?.value
            } else {
                tmpValue.value = item?.target?.value.match(/^\d{1,20}/gi) ? item?.target?.value.match(/^\d{1,20}/gi)[0] : ''
            }
        } else if (colName === 'employerIdNumber') {
            if (item?.target?.value.length === 3 && item?.target?.value.includes('-')) {
                item.target.value = item?.target?.value.replaceAll('-', '')
            } else if (item?.target?.value.length === 2 || item?.target?.value.length === 3) {
                if (item?.target?.value.length === 3) {
                    item.target.value = item?.target?.value.substring(0, 2) + '-' + item?.target?.value.substring(2)
                } else {
                    item.target.value += '-'
                }
            }
            if (/^\d{2}(-\d{7})?$/.test(item?.target?.value)) {
                tmpValue.value = item?.target?.value
            } else {
                tmpValue.value = item?.target?.value.match(/^\d{1,2}(-\d{0,7})?/gi) ? item?.target?.value.match(/^\d{1,2}(-\d{0,7})?/gi)[0] : ''
            }
        } else if (colName === 'parseAddress') {
            setBasicInfo({
                ...basicInfo,
                'address1': {
                    label: item?.add1 ? item?.add1 : '',
                    value: item?.add1 ? item?.add1 : ''
                },
                'address2': {
                    label: item?.add2 ? item?.add2 : '',
                    value: item?.add2 ? item?.add2 : ''
                },
                'city': {
                    label: item?.city ? item?.city?.value : '',
                    value: item?.city ? item?.city?.value : ''
                },
                'state': {
                    label: item?.state ? item?.state?.value : '',
                    value: item?.state ? item?.state?.value : ''
                },
                'abbreviatedState': {
                    label: item?.state ? item?.state?.value : '',
                    value: item?.state ? item?.state?.value : ''
                },
                'country': {
                    label: item?.country ? item?.country?.value : '',
                    value: item?.country ? item?.country?.value : ''
                },
                'zip': {
                    label: item?.zip ? item?.zip?.value : '',
                    value: item?.zip ? item?.zip?.value : ''
                }
            })
            return
        }

        if (colName === 'abbreviatedState') {
            if (tmpValue.value.length > 3) {
                tmpValue.value = getAbbreviatedState('', tmpValue.value)
            }
            setBasicInfo({ ...basicInfo, [colName]: tmpValue, state: tmpValue })
        } else if (item?.target?.emailContactId || item?.target?.hasOwnProperty('emailContactId')) {
            setBasicInfo({
                ...basicInfo,
                [colName]: tmpValue,
                emailContactId: {
                    label: item?.target?.emailContactId,
                    value: item?.target?.emailContactId
                }
            })
        } else if (item?.target?.phoneContactId || item?.target?.hasOwnProperty('phoneContactId')) {
            setBasicInfo({
                ...basicInfo,
                [colName]: tmpValue,
                phoneContactId: {
                    label: item?.target?.phoneContactId,
                    value: item?.target?.phoneContactId
                }
            })
        } else {
            setBasicInfo({ ...basicInfo, [colName]: tmpValue })
        }
    }

    const handleBasicInfoPhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false, tmpBasicInfo = {}) => {
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        var testPhone = phoneValue?.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '')?.replace(/[^\w\s]|[\s]/gi, '')

        if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
            setIsBasicPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            if (isUseEffect) {
                tmpBasicInfo = {
                    ...tmpBasicInfo,
                    'phone': {
                        label: phoneValue,
                        value: phoneValue,
                    }
                }
                setBasicInfo({ ...tmpBasicInfo })
            }
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode?.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (phoneValue !== '') {
            setIsValidatingBasicPhone(true)
            phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
            setIsBasicPhoneValid(phoneValidationResult?.isPhoneValid)
            setIsValidatingBasicPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            setIsBasicPhoneValid(true)
        }

        if (isUseEffect) {
            tmpBasicInfo = {
                ...tmpBasicInfo,
                'phone': {
                    label: phoneValidationResult?.phoneNumber,
                    value: phoneValidationResult?.phoneNumber,
                }
            }
            setBasicInfo({ ...tmpBasicInfo })
        }
    }

    const handleBasicInfoEmailFocusOut = async (emailValue, isRetry = false) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsBasicEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingBasicEmail(true)
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
            setIsBasicEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingBasicEmail(emailValidationResult?.isValidatingEmail)
        } else {
            setIsBasicEmailValid(true)
        }
    }

    const handleUpdateCardInfo = (colName, item, type = null, country = null, event = null) => {
        var discountValue = ''
        if (colName === 'acceptCardPaymentType') {
            if (item.length === 0) {
                setCardInfo({
                    ...cardInfo,
                    acceptCardPaymentType: [],
                    isAcceptCardPaymentByEmail: { label: 'false', value: false },
                    isAcceptCardPaymentByFax: { label: 'false', value: false },
                    isAcceptCardPaymentByPhone: { label: 'false', value: false },
                    isAcceptCardPaymentByOnlinePortal: { label: 'false', value: false },
                })
                return
            } else {
                setCardInfo({
                    ...cardInfo,
                    acceptCardPaymentType: item,
                    isAcceptCardPaymentByEmail: { label: 'false', value: item.findIndex(cardPayment => cardPayment.value === 'email') !== -1 },
                    isAcceptCardPaymentByFax: { label: 'false', value: item.findIndex(cardPayment => cardPayment.value === 'fax') !== -1 },
                    isAcceptCardPaymentByPhone: { label: 'false', value: item.findIndex(cardPayment => cardPayment.value === 'phone') !== -1 },
                    isAcceptCardPaymentByOnlinePortal: { label: 'false', value: item.findIndex(cardPayment => cardPayment.value === 'portal') !== -1 },
                })
                return
            }
        }

        if (type === 'currency' || type === 'percent') {
            var temp = "";
            temp = parseInt(item?.value.replace(/\D/g, ''));
            item.value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            if (type === 'currency') {
                if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item?.value)) {
                    setCardInfo({
                        ...cardInfo,
                        [colName]: item
                    })
                } else {
                    setCardInfo({
                        ...cardInfo,
                        [colName]: {
                            ...item,
                            value: item?.value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item.value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                        }
                    })
                }
                return
            }
            if (type === 'percent') {
                if (/^\d{0,2}(\.\d{0,2})?$/.test(item?.value)) {
                    setCardInfo({
                        ...cardInfo,
                        [colName]: item
                    })
                } else {
                    setCardInfo({
                        ...cardInfo,
                        [colName]: {
                            ...item,
                            value: item?.value?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item.value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                        }
                    })
                }
                return
            }
        }

        if (type === 'discounttype') {
            discountValue = item?.value === 'Percentage' ? cardInfo?.cardDiscountValue?.value && cardInfo?.cardDiscountValue?.value?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
                parseInt(cardInfo?.cardDiscountValue?.value.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
                : ''
                : cardInfo?.cardDiscountValue?.value

            setCardInfo({
                ...cardInfo,
                cardDiscountValue: {
                    value: discountValue
                },
                [colName]: item
            })
            return
        }

        if (type === 'fax') {
            if (item?.value === '' || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(item?.value)) {
                if (type === 'phone') {
                    // setIsPhoneValid(true)
                } else {
                    setIsFaxValid(true)
                }
            } else {
                if (type === 'phone') {
                    // setIsPhoneValid(false)
                } else {
                    setIsFaxValid(false)
                }
            }
        }

        if (colName === 'emailType') {
            setcardEmailType(item?.value)
            return
        }

        if (type === 'phone') {
            if (!item?.value) {
                colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
            } else {
                colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(false) : setIsIVRPhoneValid(false)
            }
        }

        if (type === 'extension') {
            if (/^\d{20}$/.test(item.value)) {
                item.value = item.value
            } else {
                item.value = item.value.match(/^\d{1,20}/gi) ? item.value.match(/^\d{1,20}/gi)[0] : ''
            }
        }

        if (type === 'url') {
            if (item?.value === '' || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(item?.value)) {
                if (colName === 'thirdPartyPortalUrl') {
                    setIsThirdPartyPortalUrlValid(true)
                } else {
                    setIsPortalUrlValid(true)
                }
            } else {
                if (colName === 'thirdPartyPortalUrl') {
                    setIsThirdPartyPortalUrlValid(false)
                } else {
                    setIsPortalUrlValid(false)
                }
            }
        }

        if (item?.phoneContactId || item?.hasOwnProperty('phoneContactId')) {
            setCardInfo({
                ...cardInfo,
                [colName]: item,
                phoneContactId: {
                    label: item?.phoneContactId,
                    value: item?.phoneContactId
                }
            })
        } else if (item?.ivrPhoneContactId || item?.hasOwnProperty('ivrPhoneContactId')) {
            setCardInfo({
                ...cardInfo,
                [colName]: item,
                ivrPhoneContactId: {
                    label: item?.ivrPhoneContactId,
                    value: item?.ivrPhoneContactId
                }
            })
        } else {
            setCardInfo({
                ...cardInfo,
                [colName]: item
            })
        }
    }

    const handleCardPhoneNumberFocusOut = async (event, country, phoneValue, colName) => {
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        var testPhone = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
        if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
            colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(false) : setIsIVRPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (testPhone !== '') {
            colName === 'cardPaymentByPhoneValue' ? setIsValidatingCardPhone(true) : setIsValidatingIVRPhone(true)
            phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
            colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(phoneValidationResult?.isPhoneValid) : setIsIVRPhoneValid(phoneValidationResult?.isPhoneValid)
            colName === 'cardPaymentByPhoneValue' ? setIsValidatingCardPhone(phoneValidationResult?.isValidatingPhone) : setIsValidatingIVRPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
        }
    }

    const handleCardEmailFocusOut = async (emailValue, isInitialCall = false, isRetry = false) => {
        var valid = true;
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingCardEmail(true)
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
            valid = emailValidationResult?.isEmailValid
            setIsEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingCardEmail(emailValidationResult?.isValidatingEmail)
        } else {
            setIsEmailValid(true)
        }

        if (isInitialCall) {
            return { valid }
        }
    }

    const handleChangeCardAuthorizationFormFile = (file) => {
        setCardAuthorizationFormFile(file)
    }

    const handleOnAddEmails = (emailValues) => {
        setAddCardEmailValues(emailValues)
    }

    const handleOnAddedEmails = (addedEmailValues) => {
        setAddedEmailValues(addedEmailValues)
        setcardEmailType('')
    }

    const handlePrimaryCardEmail = (primaryEmail = '', contactId = null) => {
        if (primaryEmail?.length !== 0) {
            setSupplierPrimaryCardEmail({
                email: primaryEmail,
                emailContactId: contactId
            })
        } else {
            setSupplierPrimaryCardEmail('')
        }

        if (primaryEmail.length === 0 || contactId) {
            setIsEmailValid(true)
        } else {
            setIsEmailValid(false)
        }
    }

    const handleUpdateCardFeeInfo = (colName, item, type, feeValueColumnName, feeValueType) => {
        var feeValue = ''
        if (type === 'showHideFee') {
            setCardFeeInfo({ ...cardFeeInfo, 'showHideFee': { ...cardFeeInfo?.showHideFee, [colName]: item } })
        } else {
            if (item?.value !== '$' && item?.value !== '%') {
                var temp = "";
                temp = parseInt(item.replace(/\D/g, ''));
                item = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
                if (feeValueType === '$') {
                    if (! /^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item)) {
                        item = item?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                    }
                } else {
                    if (! /^\d{0,2}(\.\d{0,2})?$/.test(item)) {
                        item = item?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                    }
                }
                setCardFeeInfo({ ...cardFeeInfo, 'feeValues': { ...cardFeeInfo?.feeValues, [colName]: item } })
            } else {
                feeValue = item?.value === '%' ? cardInfo?.[feeValueColumnName]?.value && cardInfo?.[feeValueColumnName]?.value?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
                    parseInt(cardInfo?.[feeValueColumnName]?.value.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
                    : ''
                    : cardInfo?.[feeValueColumnName]?.value

                setCardInfo({
                    ...cardInfo,
                    [feeValueColumnName]: {
                        value: feeValue,
                        label: feeValue
                    },
                    [colName]: item
                })
            }
        }
    }

    const onUpdateDeliveryMethodsFeeValues = (feeInfo) => {
        setDeliveryMethodsFeeValues(feeInfo)
        setCardFeeInfo(defaultCardFeeInfo)
        setCardInfo({
            ...cardInfo,
            'americanExpressMinPaymnet': '',
            'americanExpressMaxPayment': '',
            'visaMinPayment': '',
            'visaMaxPayment': '',
            'mastercardMinPayment': '',
            'mastercardMaxPayment': '',
            'discoverMinPayment': '',
            'discoverMinPayment': '',
        })
    }

    // to set same card acceptance values in case of genric fee structure
    const handleChangeGenericFeeInfo = (colname, value, cardColumnsArray, feeValueColumnName, cardFeeColumnsArray, type = null, colname2 = '') => {
        if (type === 'accPerCard') {
            setShowAcceptancePerCard(value)
            value ?
                setAccPerCardText('Generic Fee Structure')
                :
                setAccPerCardText('Acceptance Per Card')
            setCardInfo({
                ...cardInfo,
                [colname]: {
                    label: value,
                    value: value
                }
            })
            setCardFeeInfo({
                ...cardFeeInfo,
                'showHideFee': {
                    ...cardFeeInfo?.showHideFee,
                    showAmexMinFee: cardInfo?.['amexMinPaymentFeeValue']?.value ? true : false,
                    showAmexMaxFee: cardInfo?.['amexMaxPaymentFeeValue']?.value ? true : false,
                    showAmexIncrementalFee: (cardInfo?.['amexIncrementalFeeValue']?.value || cardInfo?.['amexIncrementalPaymentAmount']?.value) ? true : false,
                    showVisaMinFee: cardInfo?.['visaMinPaymentFeeValue']?.value ? true : false,
                    showVisaMaxFee: cardInfo?.['visaMaxPaymentFeeValue']?.value ? true : false,
                    showVisaIncrementalFee: (cardInfo?.['visaIncrementalFeeValue']?.value || cardInfo?.['visaIncrementalPaymentAmount']?.value) ? true : false,
                    showMasterMinFee: cardInfo?.['mastercardMinPaymentFeeValue']?.value ? true : false,
                    showMasterMaxFee: cardInfo?.['mastercardMaxPaymentFeeValue']?.value ? true : false,
                    showMasterIncrementalFee: (cardInfo?.['mastercardIncrementalFeeValue']?.value || cardInfo?.['mastercardIncrementalPaymentAmount']?.value) ? true : false,
                    showDiscoverMinFee: cardInfo?.['discoverMinPaymentFeeValue']?.value ? true : false,
                    showDiscoverMaxFee: cardInfo?.['discoverMaxPaymentFeeValue']?.value ? true : false,
                    showDiscoverIncrementalFee: (cardInfo?.['discoverIncrementalFeeValue']?.value || cardInfo?.['discoverIncrementalPaymentAmount']?.value) ? true : false,
                    showAmexSecondProcessingFee: cardInfo?.amexSecondProcessingFeeValue?.value ? true : false,
                    showVisaSecondProcessingFee: cardInfo?.visaSecondProcessingFeeValue?.value ? true : false,
                    showMasterSecondProcessingFee: cardInfo?.mastercardSecondProcessingFeeValue?.value ? true : false,
                    showDiscoverSecondProcessingFee: cardInfo?.discoverSecondProcessingFeeValue?.value ? true : false,
                }
            })
            return
        }

        let tmpCardInfo = { ...cardInfo }
        var feeValue = ''
        if (type === 'currency' || type === 'percent') {
            var temp = "";
            temp = value ? parseInt(value?.replace(/\D/g, '')) : '';
            value = temp ? ((temp) / 100)?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            if (type === 'currency') {
                if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/?.test(value)) {
                    value = value
                } else {
                    value = value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                }
            }
            if (type === 'percent') {
                if (/^\d{0,2}(\.\d{0,2})?$/?.test(value)) {
                    value = value
                } else {
                    value = value?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value?.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                }
            }
        }

        if (value === '$' || value === '%') {
            feeValue = value === '%' ? genericFeeValues?.[feeValueColumnName] && genericFeeValues?.[feeValueColumnName]?.toString()?.match(/^\d{0,2}(\.\d{0,2})?/gi) ?
                parseInt(genericFeeValues?.[feeValueColumnName]?.replace(',', '')?.match(/^\d{0,2}(\.\d{0,2})?/gi)[0])?.toFixed(2)
                : ''
                : genericFeeValues?.[feeValueColumnName]

            setGenericFeeValues({
                ...genericFeeValues,
                [colname]: value,
                [feeValueColumnName]: feeValue
            })

            cardFeeColumnsArray?.map((cardFeeColumn) => {
                tmpCardInfo = {
                    ...tmpCardInfo,
                    [cardFeeColumn]: {
                        label: feeValue,
                        value: feeValue
                    }
                }
            })
        } else {
            if (colname2 !== '') {
                setGenericFeeValues({
                    ...genericFeeValues,
                    [colname]: value,
                    [colname2]: false
                })
            } else {
                let tmpGenericFeeValues = { ...genericFeeValues }
                tmpGenericFeeValues[colname] = value
                if (colname === 'showCardConditions' && !value) {
                    genericConditionColumns.forEach(column => {
                        tmpGenericFeeValues = {
                            ...tmpGenericFeeValues,
                            [column.name]: column.value
                        }
                    })
                }
                setGenericFeeValues(tmpGenericFeeValues)
            }
            if (type === 'showHideFee') {
                return
            }
        }

        cardColumnsArray?.map((cardColumn) => {
            tmpCardInfo = {
                ...tmpCardInfo,
                [cardColumn]: {
                    label: value,
                    value: value
                }
            }
        })
        if (colname === 'showCardConditions' && !value) {
            cardConditionColumns.forEach(column => {
                tmpCardInfo[column.name].value = column.value
            })
        }
        setCardInfo(tmpCardInfo)
    }

    const handleUpdateAchInfo = (colName, item) => {
        if (colName === 'bankAccountNumber') {
            if (/^\d{0,17}$/.test(item?.value)) {
                setAchInfo({
                    ...achInfo,
                    [colName]: item,
                })
            } else {
                setAchInfo({
                    ...achInfo,
                    [colName]: {
                        ...item,
                        value: item?.value?.match(/^\d{0,17}/gi) ? item.value?.match(/^\d{0,17}/gi)[0] : ''
                    }
                })
            }
            return
        }
        if (colName === 'bankRoutingNumber') {
            if (/^\d{0,9}$/.test(item?.value)) {
                setAchInfo({
                    ...achInfo,
                    [colName]: item,
                })
            } else {
                setAchInfo({
                    ...achInfo,
                    [colName]: {
                        ...item,
                        value: item?.value?.match(/^\d{0,9}/gi) ? item.value?.match(/^\d{0,9}/gi)[0] : ''
                    }
                })
            }
            return
        }

        if (colName === 'emailAch') {
            if (!item?.value) {
                setIsAchEmailValid(true)
            } else {
                setIsAchEmailValid('')
            }
        }

        if (colName === 'achPortalURL') {
            if (item?.value === '' || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(item?.value)) {
                setPortalURLError(false)
            } else {
                setPortalURLError(true)
            }
        }

        if (colName === 'isAchThroughPortal') {
            if (!item?.value) {
                setPortalURLError(false)
            }
        }
        if (item?.emailContactId || item?.hasOwnProperty('emailContactId')) {
            setAchInfo({
                ...achInfo,
                [colName]: item,
                emailContactId: {
                    label: item?.emailContactId,
                    value: item?.emailContactId
                }
            })
        } else {
            setAchInfo({
                ...achInfo,
                [colName]: item
            })
        }
    }

    const handleChangeAchInstructionFile = (file) => {
        setAchInstructionFile(file)
    }

    const handleAchEmailFocusOut = async (emailValue, isInitialCall = false, isRetry = false) => {
        var valid = true;
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsAchEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingAchEmail(true)
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
            valid = emailValidationResult?.isEmailValid
            setIsAchEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingAchEmail(emailValidationResult?.isValidatingEmail)
        } else {
            setIsAchEmailValid(true)
        }

        if (isInitialCall) {
            return { valid }
        }
    }

    const handleUpdateCheckInfo = (colName, item, type = null) => {
        var discountValue = '';
        if (colName === 'isAcceptPaymentAddressFromCompanyAddress') {
            const tmpCheckInfo = { ...checkInfo }
            tmpCheckInfo['isAcceptPaymentAddressFromCompanyAddress'] = item
            tmpCheckInfo.checkAddress1 = basicInfo?.address1
            tmpCheckInfo.checkAddress2 = basicInfo?.address2
            tmpCheckInfo.checkCity = basicInfo?.city
            tmpCheckInfo.checkState = basicInfo?.state
            tmpCheckInfo.checkZip = basicInfo?.zip
            tmpCheckInfo.checkCountry = basicInfo?.country
            setCheckInfo(tmpCheckInfo)
            return
        }

        if (type === 'discounttype') {
            discountValue = item?.value === 'Percentage' ? checkInfo?.cashDiscountValue?.value && checkInfo?.cashDiscountValue?.value?.toString()?.match(/^\d{0,2}(\.\d{0,2})?/gi) ?
                parseInt(checkInfo?.cashDiscountValue?.value?.replace(',', '')?.match(/^\d{0,2}(\.\d{0,2})?/gi)[0])?.toFixed(2)
                : ''
                : checkInfo?.cashDiscountValue?.value

            setCheckInfo({
                ...checkInfo,
                cashDiscountValue: {
                    value: discountValue
                },
                [colName]: item
            })
            return
        }
        if (type === 'currency' || type === 'percent') {
            var temp = "";
            temp = parseInt(item?.value.replace(/\D/g, ''));
            item.value = temp ? ((temp) / 100)?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
            if (type === 'currency') {
                if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item?.value)) {
                    setCheckInfo({
                        ...checkInfo,
                        [colName]: item
                    })
                } else {
                    setCheckInfo({
                        ...checkInfo,
                        [colName]: {
                            ...item,
                            value: item?.value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item.value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
                        }
                    })
                }
                return
            }
            if (type === 'percent') {
                if (/^\d{0,2}(\.\d{0,2})?$/.test(item?.value)) {
                    setCheckInfo({
                        ...checkInfo,
                        [colName]: item
                    })
                } else {
                    setCheckInfo({
                        ...checkInfo,
                        [colName]: {
                            ...item,
                            value: item?.value?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item.value?.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
                        }
                    })
                }
                return
            }
        }

        if (colName === 'parseAddress') {
            setCheckInfo({
                ...checkInfo,
                'checkAddress1': {
                    label: item?.add1 ? item?.add1 : '',
                    value: item?.add1 ? item?.add1 : ''
                },
                'checkAddress2': {
                    label: item?.add2 ? item?.add2 : '',
                    value: item?.add2 ? item?.add2 : ''
                },
                'checkCity': {
                    label: item?.city ? item?.city?.value : '',
                    value: item?.city ? item?.city?.value : ''
                },
                'checkState': {
                    label: item?.state ? item?.state?.value : '',
                    value: item?.state ? item?.state?.value : ''
                },
                'checkCountry': {
                    label: item?.country ? item?.country?.value : '',
                    value: item?.country ? item?.country?.value : ''
                },
                'checkZip': {
                    label: item?.zip ? item?.zip?.value : '',
                    value: item?.zip ? item?.zip?.value : ''
                }
            })
            return
        }

        setCheckInfo({
            ...checkInfo,
            [colName]: item
        })
    }

    const handleCopyClick = () => {
        const supInfo = { ...basicInfo, ...childBasicInfo }
        const tmpSupInfo = { ...supInfo }
        delete tmpSupInfo['sic']
        delete tmpSupInfo['naics']
        delete tmpSupInfo['url']
        delete tmpSupInfo['employerIdNumber']
        handleBasicInfoEmailFocusOut(supInfo?.['email']?.value)
        setBasicInfo(tmpSupInfo)
    }

    const handleCancelClick = (type) => {
        if (type === 'basic') {
            setInitialSupplierInfo(createSupplierBasicColumns, supplierBasicInfo, listSupplierInfo)
        } else if (type === 'ach') {
            setInitialSupplierAchInfo(createSupplierAchColumns, supplierPaymentInfo)
        } else if (type === 'check') {
            setInitialSupplierCheckInfo(createSupplierCheckColumns, supplierPaymentInfo)
        } else if (type === 'card') {
            // setInitialSupplierInfo(createSupplierBasicColumns, supplierBasicInfo, listSupplierInfo)
        }
    }

    const handleBasicInfoSave = async (contactId, contactDataFromField, tmpContacts) => {
        if (basicInfo.suppliername?.value === '') {
            toast.show({
                title: 'Warning',
                description: 'Supplier Name shouldn\'t be empty!',
            })
            return
        }

        if (basicInfo?.address1?.value) {
            let address = convertAddress(basicInfo?.address1?.value)
            basicInfo.address1 = { label: address, value: address }
        }

        if (basicInfo?.zip?.value) {
            let validZip = checkZip(basicInfo?.zip?.value)
            if (!validZip) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid Zip',
                })
                return
            }
        }

        if (isValidatingBasicPhone) {
            toast.show({
                title: 'Warning',
                description: 'validating basic info phone number...!',
            })
            return
        }
        if (isValidatingBasicEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating basic info email...!',
            })
            return
        }

        if (!isBasicEmailValid && isBasicEmailValid !== '') {
            toast.show({
                title: 'Warning',
                description: 'Invalid Email!'
            })
            return
        }

        if (isBasicPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Phone Number!',
            })
            return
        }

        if (!isBasicFaxValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Fax Number!',
            })
            return
        }

        if (!isNaicsValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid NAICS Code. Must be atleast 5 or 6 digits long!.'
            })
            return
        }

        if (!isSicValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid SIC Code. Must be atleast 4 digits long!.'
            })
            return
        }

        if (basicInfo?.abbreviatedState?.value && basicInfo?.abbreviatedState?.value !== '') {
            let regex = /^[a-zA-Z\s]{2}$/
            let stateChars = '2'
            if (basicInfo?.country?.value && (basicInfo?.country?.value?.trim()?.toLowerCase() === 'australia' || basicInfo?.country?.value?.trim()?.toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{2,3}$/
                stateChars = '2 or 3'
            }
            if (!regex.test(basicInfo?.abbreviatedState?.value?.trim())) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid State. Must be ' + stateChars + ' characters long!'
                })
                return
            }
        }

        if (basicPhoneCountryCode === basicInfo?.phone?.value) {
            basicInfo['phone'] = ''
        }
        onBasicInfoSave(basicInfo, contactId, contactDataFromField, tmpContacts)
    }

    const handleCardInfoSave = async (deliveryMethodFeeValues) => {
        var invalidEmail = false
        if (isValidatingCardPhone || isValidatingIVRPhone) {
            toast.show({
                title: 'Warning',
                description: 'validating phone number...!',
                duration: 3000
            })
            return
        }

        if (cardInfo?.['isAcceptCardPaymentByFax']?.value && !cardInfo?.['cardPaymentByFaxValue']?.value) {
            toast.show({
                title: 'Danger',
                description: 'Cannot save fax acceptance without a valid fax!',
            })
            return
        }

        if (cardInfo?.['isAcceptCardPaymentByPhone'].value) {
            if ((!cardInfo?.['isAcceptPOTSPhone']?.value && !cardInfo?.['isAcceptIVRPhone']?.value) || (cardInfo?.['isAcceptPOTSPhone']?.value && (!cardInfo?.['cardPaymentByPhoneValue']?.value || cardPhoneCountryCode === cardInfo?.['cardPaymentByPhoneValue']?.value))) {
                toast.show({
                    title: 'Danger',
                    description: 'Cannot save phone acceptance without a valid phone!',
                })
                return
            }
            if (cardInfo?.['isAcceptIVRPhone']?.value && (!cardInfo?.['cardPaymentIVRPhone']?.value || ivrCountryCode === cardInfo?.['cardPaymentIVRPhone']?.value)) {
                toast.show({
                    title: 'Danger',
                    description: 'Cannot save IVR phone acceptance without a valid phone!',
                })
                return
            }
        }

        if (cardInfo?.['isAcceptCardPaymentByOnlinePortal']?.value && ((cardInfo?.['isAcceptPortal']?.value && !cardInfo?.['portalUrl']?.value) || (cardInfo?.['isAccept3rdPartyPortal']?.value && !cardInfo?.['thirdPartyPortalUrl']?.value))) {
            toast.show({
                title: 'Danger',
                description: 'Cannot save online acceptance without a valid website!',
            })
            return
        }

        if (supplierPrimaryCardEmail !== '') {
            var addEmailValuesObject = {}
            if (Object.keys(addedEmailValues)?.length > 0) {
                Object.keys(addedEmailValues)?.map((key, index) => {
                    addEmailValuesObject[key] = addedEmailValues?.[key]?.[`extra-email-name-${index + 1}`]?.email
                })
            }

            if (Object.keys(addCardEmailValues)?.length > 0) {
                Object.keys(addCardEmailValues)?.map((key, ind) => {
                    const index = Object.keys(addEmailValuesObject)?.length
                    addEmailValuesObject[index] = addCardEmailValues?.[key]?.email
                })
            }

            if (Object.values(addEmailValuesObject)?.includes(supplierPrimaryCardEmail?.email)) {
                toast.show({
                    title: 'Warning',
                    description: 'Email Address is already added!',
                })
                return
            }
            if (!isEmailValid && isEmailValid !== '') {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid Email'
                })
                return
            }
            if (cardEmailType === '') {
                toast.show({
                    title: 'Warning',
                    description: 'Please choose the Email Type from dropdown!',
                })
                return
            }
            var newIndex = Object.keys(addCardEmailValues)?.length > 0 ? (parseInt(Object.keys(addCardEmailValues)[Object.keys(addCardEmailValues)?.length - 1]) + 1) : Object.keys(addCardEmailValues)?.length
            addCardEmailValues[newIndex] = {
                'email': supplierPrimaryCardEmail?.email || '',
                'emailType': cardEmailType,
                emailContactId: supplierPrimaryCardEmail?.emailContactId || null
            }
            setSupplierPrimaryCardEmail('')
        } else {
            if (cardInfo?.['isAcceptCardPaymentByEmail']?.value && addedEmailValues?.filter(x => x).length === 0) {
                toast.show({
                    title: 'Danger',
                    description: 'Cannot save email acceptance without a valid email!',
                })
                return
            }
        }

        var invalidEmail = false;
        var emptyEmailType = false;

        if (Object.keys(addCardEmailValues)?.length > 0) {
            Object.keys(addCardEmailValues)?.map((key, index) => {
                if (addCardEmailValues?.[key] && addCardEmailValues?.[key]?.email !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(addCardEmailValues?.[key]?.email)) {
                    invalidEmail = true
                    delete addCardEmailValues?.[key]
                    return
                }
                if (addCardEmailValues?.[key] && addCardEmailValues?.[key]?.emailType === '') {
                    if (cardEmailType === '') {
                        emptyEmailType = true
                        return
                    } else {
                        addCardEmailValues[key]['emailType'] = cardEmailType
                    }
                }
            })
        }

        if (invalidEmail) {
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!',
            })
            return
        }

        if (emptyEmailType) {
            toast.show({
                title: 'Warning',
                description: 'Please choose the Email Type from dropdown!'
            })
            return
        }

        if (!isEmailValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Email!'
            })
            return
        }
        if (isPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Phone Number!' + isPhoneValid,
            })
            return
        }
        if (!isFaxValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Fax Number!',
            })
            return
        }
        if (!isThirdPartyPortalUrlValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Third Party Portal URL!',
            })
            return
        }
        if (!isPortalUrlValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Portal URL!',
            })
            return
        }
        if (isIVRPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid IVR Phone Number!',
            })
            return
        }

        if (cardInfo?.isAcceptAmexCardConditions?.value || cardInfo?.isAcceptVisaCardConditions?.value || cardInfo?.isAcceptMastercardCardConditions?.value) {
            const cardData = {}
            Object.keys(cardInfo).forEach(key => {
                if (multiSelectColumns.includes(key)) {
                    const cardSelectOptions = cardInfo[key]?.map(option => option?.value)?.join(",")
                    cardData[key] = cardSelectOptions
                } else {
                    cardData[key] = cardInfo[key].value
                }
            })

            if (cardInfo?.isAcceptAmexCardConditions?.value) {
                const isAmexCardConditions = checkAmexCardConditonsAdded(cardData)
                if (!isAmexCardConditions) {
                    toast.show({
                        title: 'Warning',
                        description: 'Please add Amex Card Conditions!',
                    })
                    return
                }
            }
            if (cardInfo?.isAcceptVisaCardConditions?.value) {
                const isVisaCardConditions = checkVisaCardConditonsAdded(cardData)
                if (!isVisaCardConditions) {
                    toast.show({
                        title: 'Warning',
                        description: 'Please add Visa Card Conditions!',
                    })
                    return
                }
            }
            if (cardInfo?.isAcceptMastercardCardConditions?.value) {
                const isMasterCardConditions = checkMasterCardConditonsAdded(cardData)
                if (!isMasterCardConditions) {
                    toast.show({
                        title: 'Warning',
                        description: 'Please add Master Card Conditions!',
                    })
                    return
                }
            }
        }

        if (cardPhoneCountryCode === cardInfo?.['cardPaymentByPhoneValue']?.value) {
            cardInfo['cardPaymentByPhoneValue'].value = ''
        }
        if (ivrCountryCode === cardInfo?.['cardPaymentIVRPhone']?.value) {
            cardInfo['cardPaymentIVRPhone'].value = ''
        }

        const tmpSupplierInfo = JSON?.parse(JSON?.stringify(cardInfo))

        if (cardAuthorizationFormFile && cardAuthorizationFormFile?.name) {
            dispatch(
                uploadCardAuthorizationFormFile(cardAuthorizationFormFile)
            ).then((response) => {
                toast.show({
                    title: 'Success',
                    description: response.data.message,
                })
                tmpSupplierInfo.cardAuthorizationFormFile = response?.data?.generatename
                onCardInfoSave(tmpSupplierInfo, deliveryMethodFeeValues, addCardEmailValues, removeEmailValues)
                setcardEmailType('')
                setIsEmailCreatedOrSelected(false)
                setRemoveEmailValues({})
            }).catch(() => {
                toast.show({
                    title: 'Warning',
                    description: "Unable to Upload Card Authorization File",
                })
            })
        } else {
            setIsEmailCreatedOrSelected(false)
            onCardInfoSave(tmpSupplierInfo, deliveryMethodFeeValues, addCardEmailValues, removeEmailValues)
            setcardEmailType('')
            setRemoveEmailValues({})
        }
        setAddCardEmailValues({})
    }

    const handleCheckInfoSave = async () => {
        if (checkInfo?.checkAddress1?.value) {
            let address = convertAddress(checkInfo?.checkAddress1?.value)
            checkInfo.checkAddress1 = { label: address, value: address }
        }

        if (checkInfo?.checkZip?.value) {
            let validZip = checkZip(checkInfo?.checkZip?.value)
            if (!validZip) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid Zip',
                })
                return
            }
        }

        if (checkInfo?.checkState?.value && checkInfo?.checkState?.value !== '' && !/^[a-zA-Z\s]+$/.test(checkInfo?.checkState?.value)) {
            toast.show({
                title: 'Warning',
                description: 'State must include only characters!',
            })
            return
        }
        onCheckInfoSave(checkInfo, achInfo)
    }

    const handleAchInfoSave = async (contactId = '', contactDataFromField = '', tmpContacts = {}) => {
        if (isValidatingAchEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating Ach acceptance email...!',
            })
            return
        }

        if (achInfo?.isAcceptAchPayments?.value && achInfo?.isAchThroughPortal?.value === false) {
            if (achInfo?.bankAccountNumber?.value && !/^\d{0,17}$/.test(achInfo?.bankAccountNumber?.value)) {
                toast.show({
                    title: 'Warning',
                    description: 'Maximum Bank Account Number is 17 digits!',
                })
                return
            }
            if (achInfo.bankRoutingNumber?.value && achInfo?.bankRoutingNumber?.value !== '' && !/^\d{9}$/.test(achInfo?.bankRoutingNumber?.value)) {
                toast.show({
                    title: 'Warning',
                    description: 'Bank Routing Number should be 9 digits!',
                })
                return
            }
        }

        if (!isAchEmailValid && isAchEmailValid !== '') {
            toast.show({
                title: 'Warning',
                description: 'Please enter Email for payment notification as email format!'
            })
            return
        }

        if (achInfo?.isAchThroughPortal?.value && (achInfo?.achPortalURL?.value && portalURLError || !/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(achInfo?.achPortalURL?.value))) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Portal URL!'
            })
            return
        }

        if (achInfo?.isAchThroughPortal?.value && !achInfo?.achPortalURL?.value) {
            toast.show({
                title: 'Warning',
                description: 'ACH Portal URL shouldn\'t be empty!'
            })
            return
        }

        // if there is uploaded file for ach instruction
        if (achInstructionFile && achInstructionFile?.name) {
            dispatch(
                uploadAchInstruction(achInstructionFile, (event) => {
                    setProgress(Math.round((100 * event.loaded) / event.total))
                })
            ).then((response) => {
                toast.show({
                    title: 'Success',
                    description: response.data.message,
                })
                achInfo.achInstructions = response?.data?.generatename
                onAchInfoSave(achInfo, checkInfo, achInstructionFile, supplierPaymentInfo, contactId, contactDataFromField, tmpContacts)
            })
        } else {
            onAchInfoSave(achInfo, checkInfo, achInstructionFile, supplierPaymentInfo, contactId, contactDataFromField, tmpContacts)
        }
    }

    const handleCompleteClick = async (e) => {
        if (basicInfo.suppliername?.value === '') {
            toast.show({
                title: 'Warning',
                description: 'Supplier Name shouldn\'t be empty!',
            })
            return
        }

        await handleBasicInfoSave()
        await handleCardInfoSave()
        await handleAchInfoSave()
        onComplete(e?.isTrusted)
    }

    const handleClickTab = (tab) => {
        tab !== currentTab && setCurrentTab(tab)
    }

    const setInitialAdvanceInfo = useCallback(async (supplierCardAccInfo) => {
        let globalAcc = supplierCardAccInfo?.cardInfo?.isAcceptGlobalAcceptance
        setIsGlobalAcceptance(globalAcc)
    }, [])

    useEffect(() => {
        if (!supplierCardAccInfo || Object.keys(supplierCardAccInfo)?.length === 0 || Object.keys(supplierCardAccInfo?.cardInfo)?.length === 0) {
            return
        }
        setInitialAdvanceInfo(supplierCardAccInfo)
    }, [supplierCardAccInfo, supplierCardAccInfo?.cardInfo, setInitialAdvanceInfo])

    const handleAdvanceCancelClick = () => {
        setInitialAdvanceInfo(supplierCardAccInfo)
    }

    const handleAdvanceSaveClick = async () => {
        let oldGlobalAcc = supplierCardAccInfo?.cardInfo?.id ? supplierCardAccInfo?.cardInfo?.isAcceptGlobalAcceptance : null
        if (isGlobalAcceptance !== oldGlobalAcc) {
            onGlobalAccSave(isGlobalAcceptance)
        }
    }

    const handleCardConditionsChange = (colName, value) => {
        const amexColumns = [
            { name: 'amexProcessingFeeType', value: '$' },
            { name: 'amexProcessingFeeValue', value: '' },
            { name: 'amexSecondProcessingFeeType', value: '$' },
            { name: 'amexSecondProcessingFeeValue', value: '' },
            { name: 'amexMinPaymentFeeType', value: '$' },
            { name: 'amexMinPaymentFeeValue', value: '' },
            { name: 'amexMaxPaymentFeeType', value: '$' },
            { name: 'amexMaxPaymentFeeValue', value: '' },
            { name: 'amexIncrementalFeeType', value: '$' },
            { name: 'amexIncrementalFeeValue', value: '' },
            { name: 'americanExpressMinPaymnet', value: '' },
            { name: 'americanExpressMaxPayment', value: '' },
            { name: 'amexIncrementalPaymentAmount', value: '' },
            { name: 'isAcceptAmexVariableFee', value: null }
        ]

        const visaColumns = [
            { name: 'visaProcessingFeeType', value: '$' },
            { name: 'visaProcessingFeeValue', value: '' },
            { name: 'visaSecondProcessingFeeType', value: '$' },
            { name: 'visaSecondProcessingFeeValue', value: '' },
            { name: 'visaMinPaymentFeeType', value: '$' },
            { name: 'visaMinPaymentFeeValue', value: '' },
            { name: 'visaMaxPaymentFeeType', value: '$' },
            { name: 'visaMaxPaymentFeeValue', value: '' },
            { name: 'visaIncrementalFeeType', value: '$' },
            { name: 'visaIncrementalFeeValue', value: '' },
            { name: 'visaMinPayment', value: '' },
            { name: 'visaMaxPayment', value: '' },
            { name: 'visaIncrementalPaymentAmount', value: '' },
            { name: 'isAcceptVisaVariableFee', value: null }
        ]

        const masterColumns = [
            { name: 'mastercardProcessingFeeType', value: '$' },
            { name: 'mastercardProcessingFeeValue', value: '' },
            { name: 'mastercardSecondProcessingFeeType', value: '$' },
            { name: 'mastercardSecondProcessingFeeValue', value: '' },
            { name: 'mastercardMinPaymentFeeType', value: '$' },
            { name: 'mastercardMinPaymentFeeValue', value: '' },
            { name: 'mastercardMaxPaymentFeeType', value: '$' },
            { name: 'mastercardMaxPaymentFeeValue', value: '' },
            { name: 'mastercardIncrementalFeeType', value: '$' },
            { name: 'mastercardIncrementalFeeValue', value: '' },
            { name: 'mastercardMinPayment', value: '' },
            { name: 'mastercardMaxPayment', value: '' },
            { name: 'mastercardIncrementalPaymentAmount', value: '' },
            { name: 'isAcceptMasterCardVariableFee', value: null }
        ]

        const amexCardFeeInfo = [
            { name: 'showAmexMinFee', value: false },
            { name: 'showAmexMaxFee', value: false },
            { name: 'showAmexIncrementalFee', value: false },
            { name: 'showAmexSecondProcessingFee', value: false }
        ]

        const visaCardFeeInfo = [
            { name: 'showVisaMinFee', value: false },
            { name: 'showVisaMaxFee', value: false },
            { name: 'showVisaIncrementalFee', value: false },
            { name: 'showVisaSecondProcessingFee', value: false }
        ]

        const masterCardFeeInfo = [
            { name: 'showMasterMinFee', value: false },
            { name: 'showMasterMaxFee', value: false },
            { name: 'showMasterIncrementalFee', value: false },
            { name: 'showMasterSecondProcessingFee', value: false }
        ]

        if (value?.value) {
            setCardInfo({
                ...cardInfo,
                [colName]: value
            })
        } else {
            var columns = amexColumns
            var cardFeeCols = amexCardFeeInfo
            if (colName === 'isAcceptVisaCardConditions') {
                columns = visaColumns
                cardFeeCols = visaCardFeeInfo
            }
            if (colName === 'isAcceptMastercardCardConditions') {
                columns = masterColumns
                cardFeeCols = masterCardFeeInfo
            }
            const tmpCardInfo = { ...cardInfo }
            const tmpCardFeeInfo = { ...cardFeeInfo }

            columns.forEach(column => {
                tmpCardInfo[column.name].value = column?.value
            })

            cardFeeCols.forEach(column => {
                tmpCardFeeInfo.showHideFee[column.name] = column?.value
            })

            tmpCardInfo[colName] = value
            setCardInfo(tmpCardInfo)
            setCardFeeInfo(tmpCardFeeInfo)
        }
    }

    const handleAddNewContact = (contactData = {}) => {
        setContactDataFromField(contactData)
        setShowAddNewContact(true)
    }

    const handleCreateContactClose = async (e, isGetContactsData = false, contact = null,) => {
        const contactId = contact?.id || null
        setShowAddNewContact(false)
        setContactDataFromField({})
        if (isGetContactsData) {
            await onGetContactsData()
        }
    }

    return (
        <div className='assign-vendor-supply mb-5'>
            <div className='list-tabs d-flex align-items-end border border-top-0 border-start-0 border-end-0 border-1'>
                {
                    tabs.map(tab => (
                        <button
                            key={tab.value}
                            type="button"
                            className={`h4 border border-1 border-bottom-0 rounded-top mb-0 page-tab list-tab pt-2 pb-2 p-4 text-black fw-bold me-3${currentTab === tab.value ? ' selected bg-dark-blue text-white pt-3 pb-3' : ''}`}
                            onClick={() => { handleClickTab(tab.value) }}
                        >
                            {tab.label}
                        </button>
                    ))
                }
                <div role="button" className='ms-auto d-flex align-items-center gap-3 flex-wrap mb-2'>
                    {currentTab === 'contacts' && (
                        <div role="button" className='ms-auto d-flex gap-2 mb-2 me-2'>
                            <button
                                type="button"
                                className="fs-4 text-white rounded ps-5 pe-5 py-3 ps-sm-5 pe-sm-5 bg-dark-blue"
                                onClick={() => { handleAddNewContact({}) }}
                                disabled={isLoading}
                            >
                                Create Contact
                            </button>
                        </div>
                    )}
                    <div role="button" className='ms-auto d-flex gap-2 mb-2'
                        onClick={() => { onShowHideAdvancedSettings(!showAdvancedSettings) }}
                    >
                        <RiSettings3Line color='#65B3E9' size={26} />
                        <h3 className='text-black fw-bold mb-0'>Advanced Settings </h3>
                    </div>
                </div>
            </div>
            {showAdvancedSettings && (
                <div className={`position-relative d-flex flex-column gap-4 bg-white rounded shadow ms-auto p-3 supplier-advance-settings ${isUpdatingAdvanceSettings ? ' loading' : ''}`}>
                    {isUpdatingAdvanceSettings && <LoaderComponent />}
                    <div className='d-flex gap-2 align-items-center'>
                        <h4 className='fw-bold mb-0 text-black'>Global Acceptance</h4>
                        <ThreeStateToggleButton customClass='ms-auto'
                            checked={isGlobalAcceptance}
                            onChange={(checked) => { setIsGlobalAcceptance(checked); }}
                        />
                    </div>
                    <div className='d-flex gap-2 ms-auto'>
                        <button type="button" className="bg-light-gray h4 mb-0 me-0 ps-3 pe-3 pt-2 pb-2 ps-sm-4 pe-sm-4 rounded text-white"
                            onClick={() => { handleAdvanceCancelClick() }}
                        >
                            Cancel
                        </button>
                        <button type="button" className="btn-green h4 mb-0 ps-3 pe-3 pt-2 pb-2 ps-sm-4 pe-sm-4 rounded"
                            onClick={() => { handleAdvanceSaveClick() }}
                        >
                            Save
                        </button>
                    </div>
                </div>
            )}
            {currentTab === 'basic' && (
                <div className={`create-master-modal p-0 border-0 position-relative${isLoadingBasicInfo ? ' loading' : ''}`}>
                    {isLoadingBasicInfo && <LoaderComponent />}
                    <SupplierBasicInfo
                        listSupplierInfo={childBasicInfo}
                        columns={createSupplierBasicColumns}
                        basicInfo={basicInfo}
                        onChangeBasicInfo={handleUpdateBasicInfo}
                        isPhoneValid={isBasicPhoneValid}
                        isValidatingPhone={isValidatingBasicPhone}
                        handleBasicInfoPhoneNumberFocusOut={handleBasicInfoPhoneNumberFocusOut}
                        handleBasicInfoEmailFocusOut={handleBasicInfoEmailFocusOut}
                        isEmailValid={isBasicEmailValid}
                        isValidatingEmail={isValidatingBasicEmail}
                        countryCode={basicPhoneCountryCode}
                        onSave={handleBasicInfoSave}
                        onCopyClick={handleCopyClick}
                        onCancel={handleCancelClick}
                        supNameForEIN={supNameForEIN}
                        isLoading={isLoading}
                        isDisabledButtons={isDisabledButtons}
                        onPhoneClick={onBasicPhoneClick}
                        setBasicInfo={setBasicInfo}
                        onAssignMaster={onAssignMaster}
                        setAllContacts={setAllContacts}
                        allContacts={allContacts}
                        listSupplierId={listSupplierInfo?.id}
                        vendorInCallsDetailsId={vendorInCallsDetailsId}
                        onGetAllContactsData={onGetContactsData}
                    />
                </div>
            )}

            {currentTab === 'contacts' && (
                <Contacts contactsData={supplierContacts || []} onGetContactsData={() => { onGetContactsData() }} />
            )}

            {currentTab === 'card' && cardInfo && Object.keys(cardInfo)?.length && (
                <div className={`assign-vendor-supply assign-vendor-component p-0 pt-5 position-relative${isLoadingCardInfo ? ' loading' : ''}`}>
                    {isLoadingCardInfo && <LoaderComponent />}
                    <div className="supply-acceptance related-supply-acceptance flex-column">
                        <SupplierCardInfo
                            setRemoveEmailValues={setRemoveEmailValues}
                            removeEmailValues={removeEmailValues}
                            columns={createSupplierCardColumns}
                            cardInfo={cardInfo}
                            childCardInfo={childCardInfo}
                            onChangeCardInfo={handleUpdateCardInfo}
                            onChangeCardAuthorizationFormFile={handleChangeCardAuthorizationFormFile}
                            cardAuthorizationFormFile={cardAuthorizationFormFile}
                            onAddEmails={handleOnAddEmails}
                            onPrimaryCardEmail={handlePrimaryCardEmail}
                            supplierPrimaryCardEmail={supplierPrimaryCardEmail}
                            addedEmailValues={addedEmailValues}
                            onAddedEmails={handleOnAddedEmails}
                            cardEmailType={cardEmailType}
                            isPhoneValid={isPhoneValid}
                            isValidatingPhone={isValidatingCardPhone}
                            isIVRPhoneValid={isIVRPhoneValid}
                            isValidatingIVRPhone={isValidatingIVRPhone}
                            handleCardPhoneNumberFocusOut={handleCardPhoneNumberFocusOut}
                            handleCardEmailFocusOut={handleCardEmailFocusOut}
                            isEmailValid={isEmailValid}
                            isValidatingEmail={isValidatingCardEmail}
                            cardFeeInfo={cardFeeInfo}
                            onUpdateCardFeeInfo={handleUpdateCardFeeInfo}
                            onUpdateDeliveryMethodsFeeValues={onUpdateDeliveryMethodsFeeValues}
                            deliveryMethodsFeeValues={deliveryMethodsFeeValues}
                            countryCode={cardPhoneCountryCode}
                            showAcceptancePerCard={showAcceptancePerCard}
                            accPerCardText={accPerCardText}
                            genericFeeValues={genericFeeValues}
                            onChangeGenericFeeInfo={handleChangeGenericFeeInfo}
                            onSave={handleCardInfoSave}
                            cardEmails={supplierCardAccInfo?.cardEmailsInfo}
                            isLoading={isLoading}
                            isDisabledButtons={isDisabledButtons}
                            onCardConditionsChange={handleCardConditionsChange}
                            setAllContacts={setAllContacts}
                            allContacts={allContacts}
                            supplierId={supplierBasicInfo?.id || null}
                            listSupplierId={listSupplierInfo?.id}
                            vendorInCallsDetailsId={vendorInCallsDetailsId}
                            onGetAllContactsData={onGetContactsData}
                            setIsEmailCreatedOrSelected={setIsEmailCreatedOrSelected}
                        />
                    </div>
                </div>
            )}

            {currentTab === 'check' && checkInfo && Object.keys(checkInfo)?.length && (
                <div className={`assign-vendor-supply assign-vendor-component pt-5 p-0 position-relative${isLoadingCheckInfo ? ' loading' : ''}`}>
                    {isLoadingCheckInfo && <LoaderComponent />}
                    <div className="supply-acceptance related-supply-acceptance flex-column">
                        <SupplierCheckInfo
                            columns={createSupplierCheckColumns}
                            checkInfo={checkInfo}
                            childPaymentInfo={childPaymentInfo}
                            onChangeCheckInfo={handleUpdateCheckInfo}
                            onSave={handleCheckInfoSave}
                            onCancel={handleCancelClick}
                            isLoading={isLoading}
                            isDisabledButtons={isDisabledButtons}
                        />
                    </div>
                </div>
            )}

            {currentTab === 'ach' && achInfo && Object.keys(achInfo)?.length && (
                <div className={`assign-vendor-supply assign-vendor-component pt-5 p-0 position-relative${isLoadingAchInfo ? ' loading' : ''}`}>
                    {isLoadingAchInfo && <LoaderComponent />}
                    <div className="supply-acceptance related-supply-acceptance flex-column">
                        <SupplierAchInfo
                            columns={createSupplierAchColumns}
                            achInfo={achInfo}
                            childPaymentInfo={childPaymentInfo}
                            achInstructionFile={achInstructionFile}
                            onChangeAchInfo={handleUpdateAchInfo}
                            onChangeAchInstructionFile={handleChangeAchInstructionFile}
                            handleAchEmailFocusOut={handleAchEmailFocusOut}
                            isEmailValid={isAchEmailValid}
                            isValidatingEmail={isValidatingAchEmail}
                            onSave={handleAchInfoSave}
                            onCancel={handleCancelClick}
                            isLoading={isLoading}
                            isDisabledButtons={isDisabledButtons}
                            setAllContacts={setAllContacts}
                            allContacts={allContacts}
                            supplierId={supplierBasicInfo?.id || null}
                            vendorInCallsDetailsId={vendorInCallsDetailsId}
                            listSupplierId={listSupplierInfo?.id}
                            onGetAllContactsData={onGetContactsData}
                        />
                    </div>
                </div>
            )}
            {showComplete && (
                <button id='complete-supplier-info-btn' className='float-end mt-4 text-white rounded h4 mb-0 width-100 bg-green pt-3 pb-3 position-sticky bottom-0' onClick={handleCompleteClick}>Complete</button>
            )}

            {showAddNewContact && (
                <>
                    <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <CreateContact
                            onClose={handleCreateContactClose}
                            supplierId={basicInfo?.id || null}
                            contactDataFromField={contactDataFromField}
                            listSupplierId={listSupplierInfo?.id || null}
                            isInCalls={basicInfo?.id ? null : true}
                            vendorInCallsDetailsId={basicInfo?.id ? null : (vendorInCallsDetailsId || null)}
                        />
                    </ModalComponent>
                </>
            )}
        </div>
    )
}

export default CreateSupplierComponent